import { apiSlice } from "../../app/api/apiSlice";

export const assignDocumentAttachmentApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		assignDocumentAttachment: builder.mutation({
			query: (credentials) => ({
				url: `/api/v1/loan/assign_doc_attachment/`,
				method: "POST",
				body: {
					loan_guid: credentials?.loanGuid,
					doc_id: credentials?.docId,
					attachment_id: credentials?.attachmentId,
				},
			}),
		}),
	}),
});

export const { useAssignDocumentAttachmentMutation } =
	assignDocumentAttachmentApiSlice;
